import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from '../CheckoutForm';
import './PaymentPage.css';

// Replace with your Stripe publishable key
const stripePromise = loadStripe('pk_live_51QAauPFDMH9yMARuDmFwg2CT77wHGO0Fq5DVgXrqWngnVG23v28KUpJwEgS9RmfMiHigI6IFsurQ2nI3uO5x4PBl00Js2CFeLg');

const PaymentPage = () => {
  return (
    <div className="payment-page">
      <h1>Buy Tokens</h1>
      <img src="token_structure.png" alt="Tokens" className="tokens" />
      <Elements stripe={stripePromise}>
        <CheckoutForm />
      </Elements>
    </div>
  );
};

export default PaymentPage;
